import { css } from '@huspy/styled-system/css';

const creditsCTAStyles = {
  button: css({
    background: 'radial-gradient(108.44% 108.44% at 50% 50%, #FFFFFF 0%, #FFFFFF 40%, #CCE6F9 100%)',
    borderWidth: '1.5px',
    borderColor: 'border-secondary',
  }),
};

export default creditsCTAStyles;
